/**
 * Zone fisiologiche (ZA, ZB, ZC).
 * Fonte dati: src/cached/json/zona_fisiologica.json (dump da tabella DB zona_fisiologica)
 */
import zoneFisiologicheJson from "@src/cached/json/zona_fisiologica.json";
import zoneJson from "@src/cached/json/zone.json";
export const zoneFisiologiche = zoneFisiologicheJson;

/**
 * Mappatura statica delle zone di allenamento (Z1-Z7) alle zone fisiologiche.
 * Usata come fallback quando LT1/LT2 non sono disponibili.
 * Z4 è un caso speciale: 50% ZB + 50% ZC.
 */
export const mappaStaticaZoneFisiologiche = {
    'Z1': 'ZA',
    'Z2': 'ZA',
    'Z3': 'ZB',
    'Z5': 'ZC',
    'Z6': 'ZC',
    'Z7': 'ZC',
};

/**
 * Zone specifiche di sport che aggregano in Z4 ma vanno interamente in ZB
 * (senza la divisione 50% ZB / 50% ZC applicata a Z4 con range intero).
 * Nuoto: B1. Gemello di ZoneFisiologiche::ZONE_TUTTO_ZB in PHP.
 */
const ZONE_TUTTO_ZB = ['B1'];

/**
 * True se la zona (id numerico o codice) va interamente in ZB (vedi ZONE_TUTTO_ZB).
 * @param {number|string} idOrCodice
 * @return {boolean}
 */
function isZonaTuttoZb (idOrCodice) {
    return ZONE_TUTTO_ZB.includes(idOrCodice) || zoneIdTuttoZb.includes(+idOrCodice);
}

/**
 * Crea un accumulatore vuoto ZA/ZB/ZC.
 * @return {Object} {ZA, ZB, ZC}
 */
export function creaAccumulatore () {
    return { ZA: 0, ZB: 0, ZC: 0 };
}

/**
 * Classificazione statica di fallback (senza LT1/LT2)
 * basata sul codice zona equivalente.
 * Gemello di ZoneFisiologiche::classificaStatica in PHP.
 * @param {Object} accumulator - {ZA, ZB, ZC}
 * @param {number} zonaId
 * @param {number} val
 * @param {number} [range] - 0=intera, 1=bassa, 2=centrale, 3=alta
 */
export function classificaStatica (accumulator, zonaId, val, range) {
    const zonaLabel = zoneByCodice[zonaId];
    if (!zonaLabel) return;

    if (zonaLabel === 'Z4') {
        if (range === 1 || isZonaTuttoZb(zonaId)) {
            accumulator['ZB'] += val;
        } else if (range === 3) {
            accumulator['ZC'] += val;
        } else {
            accumulator['ZB'] += val * 0.5;
            accumulator['ZC'] += val * 0.5;
        }
    } else if (mappaStaticaZoneFisiologiche[zonaLabel]) {
        accumulator[mappaStaticaZoneFisiologiche[zonaLabel]] += val;
    }
}

/**
 * Classifica un array di zone ({id, sec, range}) in zone fisiologiche ZA/ZB/ZC
 * con mappa statica. Gemello di ZoneFisiologiche::classificaZoneDaTotalone in PHP.
 * @param {Array} zone - [{id, sec, range}, ...] (range opzionale, 0=intera)
 * @return {Object} {ZA, ZB, ZC} in secondi, non arrotondati
 */
export function classificaZoneDaTotalone (zone) {
    const accumulator = creaAccumulatore();
    if (!Array.isArray(zone)) return accumulator;
    zone.forEach(z => {
        const sec = +z.sec || 0;
        if (sec <= 0) return;
        classificaStatica(accumulator, z.id, sec, +z.range || 0);
    });
    return accumulator;
}

const zoneEquivalenze = {};
const zoneByCodice = {};
const zoneIdTuttoZb = zoneJson
    .filter(z => ZONE_TUTTO_ZB.includes(z.codice))
    .map(z => +z.id);
zoneJson.forEach(z => {
    const agg = z.codice_aggregazione;
    if (!agg) return;
    if (!zoneEquivalenze[agg]) zoneEquivalenze[agg] = [];
    if (!zoneEquivalenze[agg].includes(z.id)) {
        zoneEquivalenze[agg].push(z.id);
    }
    zoneByCodice[z.id] = agg;
});


    /**
     * Normalizza un singolo zona_id legacy (16-22) → (1-7).
     */
    function normalizeOldZonaId (id) {
        return (id >= 16 && id <= 22) ? id - 15 : id;
    }

/**
 * Normalizza zona_id legacy in un array di elementi.
 * @param array &items Array di elementi da normalizzare (per riferimento)
 * @param string|int key Chiave che contiene il zona_id in ogni elemento
 */
function normalizeOldZonaIds (items, key) {
    return items.map((item)=>{
        if (item[key]) {
            item[key] = normalizeOldZonaId(item[key]);
        }

        return item;
    });
}

export {zoneByCodice, zoneEquivalenze, normalizeOldZonaId, normalizeOldZonaIds};
